import { cn } from "@/lib/utils";

interface Props {
  status: string;
  className?: string;
}

const map: Record<string, string> = {
  active: "bg-success-soft text-success",
  inactive: "bg-muted text-muted-foreground",
  draft: "bg-warning-soft text-warning",
  free: "bg-success-soft text-success",
  paid: "bg-primary-soft text-primary",
  demo: "bg-warning-soft text-warning",
  easy: "bg-success-soft text-success",
  medium: "bg-warning-soft text-warning",
  hard: "bg-destructive-soft text-destructive",
};

export function StatusBadge({ status, className }: Props) {
  const cls = map[status] ?? "bg-muted text-muted-foreground";
  return (
    <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium capitalize", cls, className)}>
      {status}
    </span>
  );
}
